exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.border-color[data-v-9f89c9f8] {\n  border-left: #43a047 2px solid !important;\n}\n", ""]);

// exports
